<script lang="ts">

    import LoadingView from "./LoadingView.svelte";

    export let isLoading = false;
    export let isCenter = false;


</script>


<div class="loading-content-view">
    <slot/>


    {#if isLoading}
        <div class="loading-area">
            <div class="loading" class:center={isCenter}>
                <LoadingView/>
                <LoadingView/>
                <svg class="text">
                    <use xlink:href="/img/loading.svg#svg"/>
                </svg>


                <LoadingView/>
                <LoadingView/>

            </div>

        </div>
    {/if}

</div>

<style lang="scss">
    :global(main.sp) {
        // スマートフォンの場合
        .loading-content-view {
            .loading-area {
                // 横幅いっぱいでローディング表示
                width: 100vw;
                margin-left: calc(var(--standard-sp-page-padding-left) * -1);

                > .loading {
                    // 強制的にローディング表示をセンター寄せ
                    justify-content: center;
                }
            }
        }
    }

    .loading-content-view {


        position: relative;
        width: 100%;
        height: 100%;

        min-height: 2em;

        .loading-area {
            font-size: 30px;
            position: absolute;
            top: 0px;

            // 高さを少し大きめに設定することでボーダー分を補う
            margin-top: -1px;
            margin-bottom: -1px;
            height: calc(100% + 2px);

            width: 100%;


            background-color: #fffc;

            transition: opacity 0.5s;

            opacity: 1;
            pointer-events: all;

            > .loading {
                display: flex;
                align-items: center;


                width: 100%;
                height: 100%;
                padding-top: 0.5em;
                padding-bottom: 0.5em;


                &.center {
                    justify-content: center;
                }

                .text {
                    height: 18px;
                    width: 160px;
                }

                :global(.loading-view) {
                    height: 30px;

                }

            }


        }

    }
</style>